export const defaultTopTokenList = [
  {
    id: 'USDC-BASE',
    address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
    chainId: 8453,
    name: 'USDC',
    symbol: 'USDC',
    decimals: 6,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdc.svg',
  },
  {
    id: 'USDC-ETH',
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    chainId: 1,
    name: 'USDC',
    symbol: 'USDC',
    decimals: 6,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdc.svg',
  },
  {
    id: 'USDC-BSC',
    address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    chainId: 56,
    name: 'USDC',
    symbol: 'USDC',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdc.svg',
  },
  {
    id: 'USDC-ARBITRUM',
    address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
    chainId: 42161,
    name: 'USDC',
    symbol: 'USDC',
    decimals: 6,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdc.svg',
  },
  {
    id: 'USDC-PULSECHAIN',
    address: '0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07',
    chainId: 369,
    name: 'USDC',
    symbol: 'USDC',
    decimals: 6,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07.png',
  },
  {
    id: 'USDT-BSC',
    address: '0x55d398326f99059ff775485246999027b3197955',
    chainId: 56,
    name: 'USDT',
    symbol: 'USDT',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdt.svg',
  },
  {
    id: 'USDT-ETHEREUM',
    address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    chainId: 1,
    name: 'Tether USD',
    symbol: 'USDT',
    decimals: 6,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/usdt.svg',
  },
  {
    id: 'DAI-ETHEREUM',
    address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    chainId: 1,
    name: 'Dai Stablecoin',
    symbol: 'DAI',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/dai.svg',
  },
  {
    id: 'ETH-ETHEREUM',
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    chainId: 1,
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    isNative: true,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/eth.svg',
  },
  {
    id: 'PCOCK-ETHEREUM',
    address: '0x088a72024995d9858f2fbf6529d24ca9e7954bbd',
    chainId: 1,
    name: 'PulseChain Peacock from PulseChain',
    symbol: 'PCOCK',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/pcock.svg',
  },
  {
    id: 'PDAI-ETHEREUM',
    address: '0x12d9fe4c9494dc363c6290bfdbb2bd9ed6358c13',
    chainId: 1,
    name: 'pDAI',
    symbol: 'pDAI',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/pdai.svg',
  },
  {
    id: 'PLS-PULSECHAIN',
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    chainId: 369,
    name: 'Pulsechain',
    symbol: 'PLS',
    decimals: 18,
    isNative: true,
    logoURI: 'https://raw.githubusercontent.com/LibertySwap-Finance/app-tokens/816d8782e4940b841accf4cefe2c1672cd2b7947/token-logo/others/pls.svg',
  },
  {
    id: 'ETH-PULSECHAIN',
    address: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
    chainId: 369,
    name: 'Wrapped Ether from Ethereum',
    symbol: 'WETH',
    decimals: 18,
    isNative: false,
    logoURI: 'https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x02DcdD04e3F455D838cd1249292C58f3B79e3C3C.png',
  },
]
